import React from 'react';
import { motion } from 'framer-motion';
export function FooterCTA() {
  return <section className="bg-pearl py-16 lg:py-20 relative" data-id="element-95">
      {/* Decorative top line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[2px] bg-gold" data-id="element-96"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-98">
          <h2 className="text-3xl md:text-5xl font-montserrat font-bold text-navy mb-6 leading-tight" data-id="element-99">
            Ești gata să preiei controlul asupra propriei biologii?
          </h2>
          <p className="font-lora text-[19px] md:text-xl text-text-medium mb-10 leading-relaxed" data-id="element-100">
            Nu trebuie să o faci singur. Programează o evaluare gratuită și hai
            să vedem împreună de unde începem. Fără diete. Fără obligații. Doar
            date clare și un plan care ține cont de viața ta reală.
          </p>
          <a href="https://nutrisib.club/formular" className="bg-gold text-navy font-inter font-bold uppercase tracking-wide px-10 py-5 rounded-md hover:-translate-y-1 hover:shadow-xl transition-all duration-300 text-[19px] no-underline inline-block" data-id="element-101">
            Programează Evaluarea Gratuită C.E.L.O.S.
          </a>
        </motion.div>
      </div>

      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-[2px] bg-gold" data-id="element-102"></div>
    </section>;
}